import { useMutation, useQuery } from '@tanstack/react-query';
import { mediaClient } from '@/data/@clients';

export type LessonVideoResponse = {
  url: string;
};

export const useShowLessonVideo = (lessonId?: string, enabled?: boolean) =>
  useQuery<LessonVideoResponse>({
    queryKey: ['lessonVideo', lessonId],
    queryFn: async () => await mediaClient.get(`/lessons/${lessonId}/video`),
    enabled: !!lessonId && enabled,
  });

interface UpdateLessonProgressProps {
  lessonId: string;
  progress: number;
}

export const useUpdateLessonProgress = () => {
  return useMutation({
    mutationFn: async ({ lessonId, progress }: UpdateLessonProgressProps) =>
      await mediaClient.patch(`/lessons/${lessonId}/update_progress`, {
        progress,
      }),
  });
};
